import { RootState } from "@/types/RootState";
import { LanguageState } from "@/hooks/useLanguage";
import { LoginInfo } from "@/types/LoginInfo";
import { LayersState } from "@/reducers/layers";

export const languageSelector = (state: RootState): LanguageState => state.language;
export const userSelector = (state: RootState): LoginInfo => state.user;
export const globalSelector = (state: RootState): RootState["all"] => state.all;
export const layerSelector = (state: RootState): LayersState => state.layers;
